import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { SuccessPhenotypeFilterInput } from 'libs/end-to-end/src/success-phenotype';

export const SuccessPhenotypeInputs = z
  .object({
    dropdowns: EmptyObject,
    extras: SuccessPhenotypeFilterInput,
  })
  .describe('SuccessPhenotypeInputs');

export type SuccessPhenotypeInputs = z.infer<typeof SuccessPhenotypeInputs>;

export const SuccessPhenotypeV2Request = createCustomVizRequestSchema(
  'successPhenotypeV2',
  SuccessPhenotypeInputs,
);

export type SuccessPhenotypeV2Request = z.infer<
  typeof SuccessPhenotypeV2Request
>;
